import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.loader;

export const getLoaderState = createSelector(getState, (state) => state.show);
